var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 448.4",
    style: {
      enableBackground: "new 0 0 500 448.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.1,4.5h-386c-10.1,0-18.2,8.2-18.2,18.2v15.5h357.3c14.1,0,25.6,11.4,25.6,25.6v323.5h21.4c10.1,0,18.2-8.2,18.2-18.2 V22.7C495.4,12.6,487.2,4.5,477.1,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.4,62.5h-386c-10.1,0-18.2,8.2-18.2,18.2v346.4c0,10.1,8.2,18.2,18.2,18.2h386c10.1,0,18.2-8.2,18.2-18.2V80.8 C426.6,70.7,418.5,62.5,408.4,62.5z M294.9,266.5c0,7.8-9.3,11.8-15,6.4L221.5,217c-3.4-3.3-8.8-3.3-12.2,0l-58.4,55.9 c-5.6,5.4-15,1.4-15-6.4V111.9c0-4.9,4-8.8,8.8-8.8h141.3c4.9,0,8.8,4,8.8,8.8V266.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/ProductsIcon.54b587db0be3e07ff6686c87c6a6abce.svg";
export { ForwardRef as ReactComponent };